import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const TenantContext = createContext(null);

const FALLBACK = {
    tenant_id: "default",
    brand: "Island Gold Glow Soap Co.",
    sector: "wellness",
    state: "hi",
    isolated: false,
    status: "live",
};

export function TenantProvider({ children }) {
    const [tenant, setTenant] = useState(FALLBACK);
    const [legacyTaxRate, setLegacyTaxRate] = useState(0.1);
    const [host, setHost] = useState(
        typeof window !== "undefined" ? window.location.hostname : "",
    );

    useEffect(() => {
        api.get("/hub/tenant", { params: { host } })
            .then(({ data }) => {
                setTenant(data.tenant || FALLBACK);
                if (typeof data.legacy_tax_rate === "number") {
                    setLegacyTaxRate(data.legacy_tax_rate);
                }
            })
            .catch(() => setTenant(FALLBACK));
    }, [host]);

    return (
        <TenantContext.Provider
            value={{ tenant, legacyTaxRate, host, setHost }}
        >
            {children}
        </TenantContext.Provider>
    );
}

export function useTenant() {
    const ctx = useContext(TenantContext);
    if (!ctx) throw new Error("useTenant must be used within TenantProvider");
    return ctx;
}
